/**
 * Copyright © 2020 Redbox Digital Limited. All rights reserved.
 */
define('Magento_Catalog/js/catalog/view/tesco-gallery',[
    'jquery',
    'fotorama/fotorama',
    'domReady!',
], function ($, mediaCheck) {
    'use strict';
    return function (config, el) {

        var rbd = rbd || {};
        rbd.tescoGallery = {

            /**
             * Initialisation
             */
            init: function () {
                var _self = this,
                    galleryId = $('.gallery-placeholder'),
                    gallery = galleryId.data('gallery');

                if (gallery) {
                    _self._fullScreenGallery(galleryId, gallery);
                } else {
                    galleryId.on('gallery:loaded', function () {
                        _self._fullScreenGallery(galleryId, gallery);
                    });
                }
            },

            /**
             * Custom event for open full screen image
             * @param galleryId
             * @param gallery
             * @private
             */
            _fullScreenGallery: function (galleryId, gallery) {
                $('.gallery-cta').on('click', '.tesco-gallery-fullscreen-btn', function () {
                    if (
                        !$(this).parents('.fotorama__shadows--left, .fotorama__shadows--right').length &&
                        !$(this).hasClass('fotorama-video-container')
                    ) {
                        $('.gallery-placeholder').data('gallery').fotorama.requestFullScreen();
                    }
                });

                $('.fotorama').on('click touchstart', function (e) {
                    if ($(e.target).hasClass('fotorama__nav') || 
                    $(e.target).hasClass('fotorama__stage__frame') ||
                    $(e.target).hasClass('fotorama__arr') ||
                    $(e.target).hasClass('fotorama__zoom-in') ||
                    $(e.target).hasClass('fotorama__zoom-out') ||
                    $(e.target).hasClass('fotorama__stage__shaft')
                    ) {
                        $(this).data('fotorama').cancelFullScreen()
                    }
                });
            }
        }
        rbd.tescoGallery.init();
    }
});

